import * as CONSTANTS from '../constants/constants';

const initialState = {
  uploadSuccess: null,
  uploadError: null,
  loading: false,
  courseId: null,
  sectionId: null,
  progress: 0,
  uploadSectionSuccess: null,
  uploadSectionError: null,
  deleteSuccess: null,
  deleteError: null,
};

const courseReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONSTANTS.SET_LOADING:
      return Object.assign({}, state, {
        loading: true
      });
    case CONSTANTS.UPLOAD_COURSE_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        courseId: action.docRef.id,
        progress: 0
      });
    case CONSTANTS.RESET_MSGS:
      return Object.assign({}, state, {
        uploadSuccess: null,
        uploadError: null,
        uploadSectionError: null,
        uploadSectionSuccess: null
      });
    case CONSTANTS.UPLOAD_VIDEO_PROGRESS:
      return Object.assign({}, state, {
        progress: action.progress
      });
    case CONSTANTS.UPLOAD_COURSE_VIDEO_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        progress: 0,
        uploadSuccess: CONSTANTS.UPLOAD_COURSE_SUCCESS_MSG
      });
    case CONSTANTS.UPLOAD_COURSE_SECTION_VIDEO_ERROR:
      return Object.assign({}, state, {
        loading: false,
        progress: 0,
        uploadSectionError: action.error.message
      });
    case CONSTANTS.UPLOAD_COURSE_SECTION_VIDEO_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        progress: 0,
        sectionId: action.sectionId,
        uploadSectionSuccess: CONSTANTS.UPLOAD_COURSE_SECTION_SUCCESS_MSG
      });
    case CONSTANTS.UPLOAD_COURSE_ERROR:
      return Object.assign({}, state, {
        uploadError: action.error.message,
        loading: false
      });
    case CONSTANTS.DELETE_COURSE_SUCCESS:
      return Object.assign({}, state, {
        deleteSuccess: CONSTANTS.DELETE_COURSE_SUCCESS_MSG,
        loading: false
      });
    case CONSTANTS.DELETE_COURSE_RESET_MSGS:
      return Object.assign({}, state, {
        deleteSuccess: null,
        deleteError: null,
        lodaing: false
      });
    default:
      return state;
  }
};
export default courseReducer;
